import React, { useEffect, useState } from "react";
import axios from "axios";
import { useHistory, useNavigate } from "react-router-dom";
import AdminNav from "../../Components/AdminNav.jsx/AdminNav";
import $ from "jquery";
import "../../Components/MenuForm/MenuForm.css";
import UserRow from "../../Components/QueueRow/UserRow";

const NewUser = (props) => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [employee, setEmployee] = useState();
  const [data, setData] = useState([]);
  const [hidden, setHidden] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const usersEmail = window.localStorage.getItem("e");

  const runSuccess = async () => {
    try {
      const dataa = await axios.get("/users");
      setData(dataa.data);
      setHidden(false);
      setLoading(false);
     } catch {
      setHidden(false);
      setLoading(false);
    }
  }

  useEffect(() => {
    axios
      .get(`/user/${usersEmail}`)
      .then((res) => {
        if (res.data.employee === true) {
          setHidden(true);
          setLoading(false);
        } else {
            runSuccess()
        }
      })
      .catch((err) => {
        setHidden(true);
        setLoading(false);
      });
  }, [loading, usersEmail]);

  const handleFormSubmit = (e) => {
    e.preventDefault();
    let realStatus = employee;
    realStatus = realStatus !== true;
    axios
      .post("/userSignup", {
        firstName,
        lastName,
        phone,
        email,
        password,
        confirmPassword,
        employee: realStatus,
      })
      .then((response) => {
        navigate("/admin/menu");
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const onPhoneChange = (event) => {
    $(".number").keyup(function () {
      if (this.value.length === this.maxLength) {
        $(this).next(".number").focus();
      }
    });
    const val1 = $("#number1").val();
    const val2 = $("#number2").val();
    const val3 = $("#number3").val();
    setPhone(val1 + "-" + val2 + "-" + val3);
  };

  const setEmployeeStatus = (e) => {
    setEmployee($(".switch1").find("input[type=checkbox]")[0].checked);
  };

  if (loading) return null;

  if (hidden)
    return (
      <>
        <AdminNav />
        <div className="container login-card">
          <div className="row">
            <div className="col s12 m6">
              <div className="card adminMenu">
                <div className="card-content white-text">
                  <h3 className="center-align formHead">
                    Only Admin accounts can view this page.
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );

  return (
    <>
      <AdminNav />
      <div className="container login-card">
         <div className="order-table" >

        <table className="left">
          <thead>
            <tr>
            <th className="table-col">Type</th>
              <th className="table-col">First</th>
              <th className="table-col">Last</th>
              <th className="table-col">Email</th>
              <th className="table-col">Phone Number</th>
              <th className="table-col">Delete</th>
            </tr>
          </thead>
        </table>
        </div>
        {data.map((user) => {
          return (
            <React.Fragment>
             <UserRow user={user}/>
            </React.Fragment>
          );
        })}
      </div>
      <div className="container login-card">
        <div className="row">
          <div className="col s12 m6">
            <div className="card adminMenu">
              <div className="card-content white-text">
                <h3 className="center-align formHead">Create a User</h3>
                <div className="row">
                  <form className="col s12" onSubmit={handleFormSubmit}>
                    <div className="row">
                      <div className="input-field col s12">
                        <div className="row"></div>
                        <input
                          id="first_name"
                          type="text"
                          className="validate userFormInput blk"
                          value={firstName}
                          onChange={(e) => {
                            setFirstName(e.target.value);
                          }}
                        />
                        <label htmlFor="firstName">First Name</label>
                      </div>
                      <div className="input-field col s12">
                        <div className="row"></div>
                        <input
                          id="last_name"
                          type="text"
                          className="validate userFormInput blk"
                          value={lastName}
                          onChange={(e) => {
                            setLastName(e.target.value);
                          }}
                        />
                        <label htmlFor="lastName">Last Name</label>
                      </div>
                      <div className="input-field col s12">
                        <div className="row"></div>
                        <input
                          id="email"
                          type="email"
                          className="validate userFormInput blk"
                          value={email}
                          onChange={(e) => {
                            setEmail(e.target.value);
                          }}
                        />

                        <label htmlFor="email">Email</label>
                      </div>
                      <div className="input-field col s12">
                        <div className="row"></div>
                        <input
                          type="text"
                          id="number1"
                          className="number sign-input validate col s2"
                          maxlength="3"
                          size="3"
                          onChange={(e) => onPhoneChange(e)}
                        />{" "}
                        -{" "}
                        <input
                          type="text"
                          id="number2"
                          className="number sign-input validate col s2"
                          maxlength="3"
                          size="3"
                          onChange={(e) => onPhoneChange(e)}
                        />{" "}
                        -{" "}
                        <input
                          type="text"
                          id="number3"
                          className="number sign-input validate col s4"
                          maxlength="4"
                          size="5"
                          onChange={(e) => onPhoneChange(e)}
                        />
                        <label htmlFor="phone">Phone #</label>
                      </div>
                    </div>
                    <div className="row">
                      <div className="input-field col s12">
                        <div className="row"></div>
                        <input
                          id="password"
                          type="password"
                          className="validate userFormInput blk"
                          value={password}
                          onChange={(e) => {
                            setPassword(e.target.value);
                          }}
                        />
                        <label htmlFor="password">Password</label>
                      </div>
                      <div className="input-field col s12">
                        <div className="row"></div>
                        <input
                          id="confirmPassword"
                          type="password"
                          className="validate userFormInput blk"
                          value={confirmPassword}
                          onChange={(e) => {
                            setConfirmPassword(e.target.value);
                          }}
                        />
                        <label htmlFor="password">Confirm Password</label>
                      </div>
                      <div className="row"></div>
                      <div className="row"></div>
                      <div className="col s6 center">
                        <div className="switch switch1">
                          <label className="blk user-role">
                            Employee
                            <input
                              type="checkbox"
                              onClick={(e) => setEmployeeStatus(e)}
                            />
                            <span className="lever"></span>
                            Admin
                          </label>
                        </div>
                      </div>
                      <div className="col s6 center">
                        <button
                          className="btn waves-effect waves-light submit-button"
                          type="submit"
                          name="action"
                        >
                          Create User
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewUser;
